import "./ProductsReviews.module.css";
import Header from "@/reusable_sections/Header";
import Categories from "./sections/Categories";
import EditorialFormats from "./sections/EditorialFormats";
import Tools from "./sections/Tools";
import Footer from "@/reusable_sections/Footer";
export default function ProductsReviewsPage() {
  return <div>
      <Header />
      <Categories />
      <EditorialFormats />
      <Tools />
      <Footer />
    </div>;
}